export default __webpack_public_path__ + "static/20-ead08be8d82a72b711bc4aa778e0bdab.png";